import { Badge, Menu } from "@marekl/adminer/components";
import { formatDate } from "@marekl/adminer/format";
import { documentConsentBadge } from "../../lib/memberState";
import { documentFileUrl, type TeamSeasonDocument } from "../../lib/queries/seasonDocuments";
import styles from "./DocumentConsentBadge.module.css";

/** One document's line: what was agreed, by whom and when. */
function consentLine(d: TeamSeasonDocument): string {
  if (!d.consent) return `${d.name}: chybí souhlas`;
  const who = d.consent.impersonator_name
    ? `${d.consent.user_name} (v zastoupení: ${d.consent.impersonator_name})`
    : d.consent.user_name;
  const when = formatDate(d.consent.agreed_at);
  const head = `${d.name} (verze ${d.consent.version}) · ${who} · ${when}`;
  return d.agreed ? head : `${head} · chybí souhlas s verzí ${d.version}`;
}

/**
 * „Souhlasili s dokumenty" / „Chybí souhlas s dokumenty" for one club in the
 * active season, opening the record behind it: per document the version,
 * who ticked it and when, linked to the exact PDF that was agreed.
 *
 * Renders nothing when the season has no documents.
 */
export function DocumentConsentBadge({ documents }: { documents: TeamSeasonDocument[] }) {
  const badge = documentConsentBadge(documents);
  if (!badge) return null;
  return (
    <Menu
      triggerClassName={styles.trigger}
      trigger={<Badge variant={badge.variant}>{badge.label} ▾</Badge>}
      items={documents.map((d) => ({
        id: d.document_id,
        label: consentLine(d),
        href: documentFileUrl(d.consent?.version_id ?? d.version_id),
      }))}
    />
  );
}
